import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { UserService } from '../../../layout/service/user.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Router } from '@angular/router';
import { SelectModule } from 'primeng/select';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-form',
    imports: [
        ButtonModule,
        TableModule,
        InputTextModule,
        DialogModule,
        SelectModule,
        FormsModule,
        ToastModule,
        ConfirmDialog,
        CommonModule
    ],
    providers: [ConfirmationService, MessageService],
    template: `
        <p-toast />
        <p-confirmdialog />
        <div class="card">
            <div class="flex justify-between items-center">
                <h3 class="text-primary font-bold">Manajemen Formulir OSCE</h3>
                <p-button severity="success" label="Tambah Formulir" icon="pi pi-plus" (click)="showAddFormDialog()"></p-button>
            </div>
            <p-table #dt [value]="forms" stripedRows [tableStyle]="{ 'min-width': '50rem' }" [rowHover]="true" [rows]="10"
                [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [loading]="loading"
                [paginator]="true" currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} entri"
                [filterDelay]="0" [globalFilterFields]="['KATEGORI','TITLE','SKDI']">

                <ng-template pTemplate="caption">
                    <div class="flex items-center">
                        <div>
                            <input pInputText type="text" (input)="onInput($event, dt)" placeholder="Cari kata kunci" class="input input-bordered w-full" />
                        </div>
                    </div>
                </ng-template>

                <ng-template #header>
                    <tr>
                        <th class="text-center">No</th>
                        <th pSortableColumn="CREATED_AT">Tanggal <p-sortIcon field="CREATED_AT"></p-sortIcon></th>
                        <th pSortableColumn="KATEGORI">Kategori <p-sortIcon field="KATEGORI"></p-sortIcon></th>
                        <th pSortableColumn="SKDI">SKDI <p-sortIcon field="SKDI"></p-sortIcon></th>
                        <th pSortableColumn="TITLE">Judul <p-sortIcon field="TITLE"></p-sortIcon></th>
                        <th pSortableColumn="CREATED_BY">Oleh <p-sortIcon field="CREATED_BY"></p-sortIcon></th>
                        <th class="text-center">Aksi</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-result let-i="rowIndex">
                    <tr>
                        <td class="text-center">{{ i + 1 }}</td>
                        <td>{{ result.CREATED_AT | date: 'yyyy-MM-dd' }}</td>
                        <td>{{ result.KATEGORI }}</td>
                        <td>{{ result.SKDI }}</td>
                        <td>{{ result.TITLE }}</td>
                        <td>{{ result.CREATED_BY }}</td>
                        <td class="flex justify-center space-x-2">
                            <p-button icon="pi pi-eye" variant="text" [raised]="true" severity="info" class="mr-2" (click)="showViewPreview(result)" [disabled]="processing"></p-button>
                            <p-button icon="pi pi-pencil" variant="text" [raised]="true" severity="warn" class="mr-2" (click)="showEditFormDialog(result)" [disabled]="processing"></p-button>
                            <p-button icon="pi pi-trash" variant="text" [raised]="true" severity="danger" class="mr-2" (click)="onDelete($event, result)" [disabled]="processing"></p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <p-dialog header="Tambah/Ubah Formulir" [(visible)]="formDialogVisible" [modal]="true" [closable]="false" position="top" [draggable]="false" [style]="{width: '30vw'}">
                <div class="space-y-4">
                    <div>
                        <label for="category" class="block text-sm font-medium text-gray-700">Kategori</label>
                        <p-select id="category" [options]="categories" [(ngModel)]="selectedCategory" optionLabel="KATEGORI" placeholder="Pilih kategori" class="w-full"></p-select>
                        <small class="text-gray-500">Pilih kategori, pastikan formulir belum tersedia</small>
                    </div>
                    <div>
                        <label for="title" class="block text-sm font-medium text-gray-700">Judul</label>
                        <input id="title" pInputText [(ngModel)]="title" placeholder="Masukkan judul SKDI" class="input input-bordered w-full" />
                        <small class="text-gray-500">Masukkan judul SKDI, pastikan judul belum tersedia</small>
                    </div>
                    <div>
                        <label for="skdi" class="block text-sm font-medium text-gray-700">SKDI</label>
                        <input id="skdi" pInputText [(ngModel)]="skdi" placeholder="Masukkan SKDI" class="input input-bordered w-full" />
                        <small class="text-gray-500">Masukkan SKDI, pastikan SKDI belum tersedia</small>
                    </div>
                </div>
                <div class="flex justify-end space-x-2 mt-4">
                    <p-button label="Batal" icon="pi pi-times" class="btn" severity="secondary" (click)="formDialogVisible = false" [disabled]="processing"></p-button>
                    <p-button label="Simpan" icon="pi pi-check" class="btn btn-primary" (click)="onSaveForm()" [disabled]="processing"></p-button>
                </div>
            </p-dialog>
        </div>
    `
})
export class Form implements OnInit {
    constructor(
        private userService: UserService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private route: Router
    ) { }

    forms: any[] = [];
    loading: boolean = true;
    categories: any[] = [];
    formDialogVisible: boolean = false;
    selectedCategory: any = null;
    title: string = '';
    skdi: string = '';
    currentUser: any = {};
    editingForm: any = null;
    processing: boolean = false;

    ngOnInit(): void {
        this.userService.getOsce().then((response) => {
            this.forms = response.data;
            this.loading = false;

        })

        this.userService.getCategoriesActive().then((response) => {
            this.categories = response.data;
        })

        const userData = localStorage.getItem('user');
        this.currentUser = userData ? JSON.parse(userData) : null;
    }

    onInput(event: Event, dt: any) {
        const inputElement = event.target as HTMLInputElement;
        dt.filterGlobal(inputElement.value, 'contains');
    }

    showAddFormDialog() {
        this.resetFormFields();
        this.formDialogVisible = true;
    }

    showEditFormDialog(form: any) {
        this.editingForm = form;
        this.selectedCategory = this.categories.find(category => category.KATEGORI === form.KATEGORI);
        this.title = form.TITLE;
        this.skdi = form.SKDI;
        this.formDialogVisible = true;
    }

    onSaveForm() {
        if (this.selectedCategory && this.title && this.skdi) {
            this.processing = true;
            if (this.editingForm) {
                // Update form logic
                this.userService.updateOSCE({
                    ID_OSCE: this.editingForm.ID_OSCE,
                    ID_KATEGORI: this.selectedCategory.ID,
                    SKDI: this.skdi,
                    TITLE: this.title,
                    UPDATED_BY: this.currentUser.USERNAME
                }).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form updated successfully' });
                    this.ngOnInit();
                    this.formDialogVisible = false;
                }).catch(() => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update form' });
                }).finally(() => {
                    this.processing = false;
                });
            } else {
                // Add form logic
                this.userService.addOSCE({
                    ID_KATEGORI: this.selectedCategory.ID,
                    SKDI: this.skdi,
                    TITLE: this.title,
                    CREATED_BY: this.currentUser.USERNAME,
                    IS_ACTIVED: 1
                }).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form created successfully' });
                    this.ngOnInit();
                    this.formDialogVisible = false;
                }).catch(() => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create form' });
                }).finally(() => {
                    this.processing = false;
                });
            }
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all fields' });
        }
    }

    resetFormFields() {
        this.editingForm = null;
        this.selectedCategory = null;
        this.title = '';
        this.skdi = '';
    }

    onDelete(event: Event, form: any) {
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Do you want to delete this record?',
            header: 'Danger Zone',
            icon: 'pi pi-info-circle',
            rejectLabel: 'Cancel',
            rejectButtonProps: {
                label: 'Cancel',
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: 'Delete',
                severity: 'danger',
            },

            accept: () => {
                this.processing = true;
                this.userService.deleteOSCE({ ID_OSCE: form.ID_OSCE }).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form deleted successfully' });
                    this.ngOnInit();
                }).catch(() => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete form' });
                }).finally(() => {
                    this.processing = false;
                });
            },
            reject: () => {
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
            },
        });
    }

    showViewPreview(result:any){
        localStorage.setItem('results', JSON.stringify(result));
        this.route.navigate(['app/osce/preview']);
    }
}
